import Footer from '../../../../components/Footer/Footer';
import InnerNav from '../../../../components/InnerNav/InnerNav';
import './Basic.scss'


const Basic = () => {

    return(
        <div className="basic-container">
              <InnerNav/>
              <div className="basic-contents">
                
              
            <div className="basic-content">
               
              <h1>Welcome</h1>
              <p>Your birth details have been gracefully received by the cosmos. With every moment, the ancient energies of the universe begin to stir — decoding the silent language of the stars written at the hour of your birth.

                🪐 The planets are aligning, the houses are forming, and the divine script of your life is being drawn across the celestial canvas. Your Kundali — a sacred reflection of who you are, where you've come from, and the path that lies ahead — is now being woven by time itself.

                As we process your information, let the stillness of this moment remind you — you are not just a person born in a place and time... you are a unique spark of the universe, encoded with a purpose, a rhythm, and a destiny.

                ✨ Sit back and take a deep breath. Your astrological journey begins now..</p>
            </div>
            </div>
            <Footer/>
        </div>
    )
}
export default Basic;